var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
/**
 * A treatment plan a logged-in patient may book a follow-up against (PRD #1343,
 * RS-001). Deliberately minimal and record-independent so the future iframe
 * surface can render it unchanged: the plan's name/code, its remaining unbooked
 * allowance, and the continuity therapist's display name — nothing else.
 *
 * Only plans that are *eligible* for one-tap follow-up booking are emitted:
 * exactly one Heilmittel, at least one unbooked unit, and an established
 * (previously-seen) therapist. Multi-Heilmittel and exhausted plans are
 * surfaced elsewhere without a booking affordance.
 */
export class PatientBookablePlanDto {
    treatmentPlanId;
    /** The single Heilmittel's short code (e.g. "KG"). */
    treatmentCode;
    /** The single Heilmittel's display name (e.g. "Krankengymnastik"). */
    treatmentName;
    /** PLANNED units with no appointment yet — the hard booking cap. */
    remainingUnits;
    /**
     * Default count for the multi-slot pass — "one week's worth" (the plan's
     * weekly frequency), never above `remainingUnits` (PRD #1343, RS-004). The
     * stepper starts here; the patient may step down to 1 or up to
     * `remainingUnits`.
     */
    defaultWeeklyCount;
    /** The established (continuity) therapist's display name. */
    therapistName;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientBookablePlanDto.prototype, "treatmentPlanId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientBookablePlanDto.prototype, "treatmentCode", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientBookablePlanDto.prototype, "treatmentName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], PatientBookablePlanDto.prototype, "remainingUnits", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], PatientBookablePlanDto.prototype, "defaultWeeklyCount", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientBookablePlanDto.prototype, "therapistName", void 0);
//# sourceMappingURL=patient-bookable-plan.dto.js.map